<template>
  <b-row class="pro-content">
    <b-col cols="12" md="9" offset-md="3" v-if="showType === -1 || showType === 0">
      <h6>彩色日拋</h6>
      <!--491px以上顯示product-1-->
      <div id="product-1" class="carousel slide" data-ride="">
        <!-- Indicators -->
        <ol class="carousel-indicators" v-if="getGroup0.totalPage > 0">
          <li data-target="#product-1" data-slide-to="0" class="active" v-for="i in getGroup0.totalPage"
              :key="i" @click.prevent="changePage(0, i)"> {{ i }}
          </li>
        </ol>
        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox">
          <b-row class="item active">
            <b-col cols="6" sm="4" class="box" v-for="product in getGroup0.filterList" :key="product.productId">
              <a href="#" class="listBox" @click.prevent="showProductList(product)">
                <div class="imgBox">
                  <img :src="product.smallURL" class="img-lg">
                  <img :src="product.smallHoverURL" class="img-lg-hover">
                </div>
                <div class="btnBox">
                  {{ product.name }}
                </div>
                <div class="price">TWD$<span>{{ product.price }}</span></div>
              </a><!--listBox-->
            </b-col>
          </b-row>
        </div>
      </div><!-- product-1 slide-->
      <!--490px以下顯示product-1-m-->
      <div id="product-1-m" class="carousel slide" data-ride="">
        <!-- Indicators -->
        <ol class="carousel-indicators" v-if="getGroup0.totalPage > 0">
          <li data-target="#product-1" data-slide-to="0" :class="getGroup0.index === i ? 'active': ''"
              v-for="i in getGroup0.totalPage"
              :key="i" @click.prevent="changePage(0, i)">{{ i }}</li>
        </ol>
        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox">
          <b-row class="item active">
            <b-col cols="6" sm="4" class="box" v-for="product in getGroup0.filterList" :key="product.productId">
              <a href="#" class="listBox" @click.prevent="showProductList(product)">
                <div class="imgBox">
                  <img :src="product.smallURL" class="img-lg">
                  <img :src="product.smallHoverURL" class="img-lg-hover">
                </div>
                <div class="btnBox">
                   {{ product.name }}
                </div>
                <div class="price">TWD$<span>{{ product.price }}</span></div>
              </a><!--listBox-->
            </b-col>
          </b-row>
        </div>
      </div><!-- product-1-m slide-->
    </b-col>

    <b-col cols="12" md="9" offset-md="3" v-if="showType === -1 || showType === 1">
      <h6>彩色月拋</h6>
      <b-row class="row-pc">
        <b-col cols="6" sm="4" class="box" v-for="product in getGroup1.filterList" :key="product.productId">
          <a href="#" class="listBox" @click.prevent="showProductList(product)">
            <div class="imgBox">
              <img :src="product.smallURL" class="img-lg">
              <img :src="product.smallHoverURL" class="img-lg-hover">
            </div>
            <div class="btnBox">
              {{ product.name }}
            </div>
            <div class="price">TWD$<span>{{ product.price }}</span></div>
          </a><!--listBox-->
        </b-col>
        <b-col cols="12" class="pageBar" v-if="getGroup1.totalPage > 0">
          <a href="#" v-for="i in getGroup1.totalPage"  :key="i"
             :class="getGroup1.index === i ? 'pageBtn now' : 'pageBtn'"
             @click.prevent="changePage(1, i)">{{ i }}</a>
        </b-col>
      </b-row><!--row-pc-->

      <b-row class="row-m">
        <b-col cols="6" sm="4" class="box" v-for="product in getGroup1.filterList" :key="product.productId">
          <a href="#" class="listBox" @click.prevent="showProductList(product)">
            <div class="imgBox">
              <img :src="product.smallURL" class="img-lg">
              <img :src="product.smallHoverURL" class="img-lg-hover">
            </div>
            <div class="btnBox">
              {{ product.name }}
            </div>
            <div class="price">TWD$<span>{{ product.price }}</span></div>
          </a><!--listBox-->
        </b-col>
        <b-col cols="12" class="pageBar" v-if="getGroup1.totalPage > 0">
          <a href="#" v-for="i in getGroup1.totalPage"  :key="i"
             :class="getGroup1.index === i ? 'pageBtn now' : 'pageBtn'"
             @click.prevent="changePage(1, i)">{{ i }}</a>
        </b-col>
      </b-row><!--row-m-->
    </b-col>

    <b-col cols="12" md="9" offset-md="3" v-if="showType === -1 || showType === 2">
      <h6>透明日拋</h6>
      <b-row class="item active">
        <b-col cols="6" sm="4" class="box" v-for="product in getGroup3.filterList" :key="product.productId">
          <a href="#" class="listBox" @click.prevent="showProductList(product)">
            <div class="imgBox">
              <img :src="product.smallURL" class="img-lg">
              <img :src="product.smallHoverURL" class="img-lg-hover">
            </div>
            <div class="btnBox">
              {{ product.name }}
            </div>
            <div class="price">TWD$<span>{{ product.price }}</span></div>
          </a><!--listBox-->
        </b-col>

        <b-col cols="12" class="pageBar" v-if="getGroup3.totalPage > 0">
          <a href="#" target="_self"  v-for="i in getGroup3.totalPage"  :key="i"
             :class="getGroup3.index === i ? 'pageBtn now' : 'pageBtn'"
             @click="changePage(3, i)">{{ i }}</a>
        </b-col>
      </b-row>
    </b-col>
  </b-row><!--row-->
</template>

<script>
import APIService from "@/utils/APIService";
import common from "@/mixins/common";
export default {
  name: "product",
  props: {
    showType: Number,
  },
  data(){
    return {
      tab: 0 ,
      slide: 0,
      page: {},
      products:[],
      groups0 :{
        index: 1,
        limit: 6,
        total: 0,
        totalPage: 0,
        list: [],
        filterList:[],
      },
      groups1 :{
        index: 1,
        limit: 6,
        total: 0,
        totalPage: 0,
        list: [],
        filterList:[],
      },
      groups2 :{
        index: 1,
        limit: 6,
        total: 0,
        totalPage: 0,
        list: [],
        filterList:[],
      },
      groups3 :{
        index: 1,
        limit: 6,
        total: 0,
        totalPage: 0,
        list: [],
        filterList:[],
      },
      group: '',
    }
  },
  mixins:[common],
  created() {
    this.toTop();
    if (this.isMobile){
      this.getGroup0.limit = 6;
      this.getGroup1.limit = 6;
      this.getGroup2.limit = 6;
      this.getGroup3.limit = 6;
    }
    this.loadData();
  },
  computed:{
    getProductList(){
      return this.products;
    },
    getGroup0(){
      return this.groups0;
    },
    getGroup1(){
      return this.groups1;
    },
    getGroup2(){
      return this.groups2;
    },
    getGroup3(){
      return this.groups3;
    }
  },
  methods:{
    showToTop(){
      if (this.isMobile){
        this.toTop();
      }
    },
    showDetail(){
      console.log(`showDetail`)
      this.$emit('showDetail', -1);
      this.showToTop();
    },
    async loadData(){
      const query = { pageIndex: 1, limit: 100, type: 0, sortBy:'sort', sortByValue: 'ASC' };
      const res = await APIService.getProductList({ info: query });

      this.group = this.$route.query.group;
      console.log(`loadData showType == ${this.showType}`);

      const result = res.data;
      console.log(`loadData == ${JSON.stringify(query)}`);

      if (result.code === 0){
        this.page = result.body.header;
        this.products = result.body.list;
        console.log(`products == ${JSON.stringify(this.products)}`);
        // console.log(`products == ${JSON.stringify(this.products)}`);
        for (let product of this.products){
          if (product.category === 0 && product.disposable === 0){
            this.groups0.list.push(product);
          }
          if (product.category === 0 && product.disposable === 1){
            this.groups1.list.push(product);
          }
          if (product.category === 1 && product.disposable === 0){
            this.groups3.list.push(product);
          }
        }

        this.groups0.total = this.groups0.list.length;
        this.groups0.totalPage = Math.ceil(this.groups0.total / this.groups0.limit);
        this.setGroupList(this.groups0);

        this.groups1.total = this.groups1.list.length;
        this.groups1.totalPage = Math.ceil(this.groups1.total / this.groups1.limit);
        this.setGroupList(this.groups1);

        this.groups2.total = this.groups2.list.length;
        this.groups2.totalPage = Math.ceil(this.groups2.total / this.groups2.limit);

        this.groups3.total = this.groups3.list.length;
        this.groups3.totalPage = Math.ceil(this.groups3.total / this.groups3.limit);
        this.setGroupList(this.groups3);
        // console.log(`groups0 == ${this.groups0.total}`);
        // console.log(`groups1 == ${JSON.stringify(this.groups1)}`);
        // console.log(`groups2 == ${this.groups2.total}`);
        // console.log(`groups3 == ${this.groups3.total}`);
      }
    },
    setGroupList(group){
      const begin = (group.index - 1) < 0 ? 0 : (group.index - 1) * group.limit;
      const end = group.total > (group.index * group.limit) ?
          group.index  * group.limit :
          group.total ;
      console.log(`page ${begin} / ${end}`);
      const sort = group.list.sort((s1, s2)=> {
        if (s1.sort > s2.sort) return 1;
        if (s1.sort < s2.sort) return -1;
        return 0;
      });
      console.log(`排序後 ${JSON.stringify(sort)}`);
      group.filterList =  sort.slice(begin, end);
    },
    changePage(index, page){
      console.log(`changePage == ${index} , ${page}`);
      if (index === 0){
        this.groups0.index = page;
        this.setGroupList(this.groups0);
      }
      if (index === 1){
        this.groups1.index = page;
        this.setGroupList(this.groups1);
      }
      if (index === 3){
        this.groups3.index = page;
        this.setGroupList(this.groups3);
      }
    },
    showProductList(product){
      // this.$router.push({ path: 'productList' , query: { group: product.productGroup }});
      const query = { tab: 3, group: product.productGroup, groupName: product.name, disposable:product.disposable, enableType:1 };
      localStorage.setItem('cache_query', JSON.stringify(query));
      this.$emit('showDetail', query);
      this.showToTop();
    }
  }
}
</script>

<style scoped>

</style>
